module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/app/layouts/simple-layout.component.html
// module id = ../../../../../src/app/layouts/simple-layout.component.html
// module chunks = main